"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/PNFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_187)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_187`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-8.04004 0H27.96V24.0003H-8.04004V0Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M20.1339 9.45627L18.96 9.84756L17.7861 9.45627L17.3948 8.47801L17.7861 7.49976H20.1339L19.7426 8.47801L20.1339 9.45627Z",
					fill: "#ACABB1"
				}),
				/* @__PURE__ */ n("path", {
					d: "M16.2208 9.4563V13.7606C16.2208 15.8574 18.96 16.4998 18.96 16.4998C18.96 16.4998 21.6992 15.8573 21.6992 13.7606V9.4563H16.2208Z",
					fill: "#338AF3"
				}),
				/* @__PURE__ */ n("path", {
					d: "M16.4678 14.7802C17.1411 16.073 18.96 16.4997 18.96 16.4997C18.96 16.4997 20.7789 16.073 21.4522 14.7802L18.96 10.6301L16.4678 14.7802Z",
					fill: "#6DA544"
				}),
				/* @__PURE__ */ n("path", {
					d: "M21.6992 13.7172L18.96 9.4563L16.2208 13.7172V13.7606C16.2208 14.1486 16.3148 14.4868 16.4678 14.7804L18.96 10.9035L21.4522 14.7804C21.6052 14.4868 21.6992 14.1487 21.6992 13.7606V13.7172Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.95998 0V2.14826L6.78417 3.91304H9.95998V8.08672H5.80429L9.95998 10.3954V11.9998H8.08404L2.91649 9.12917V11.9998H-0.996548V8.58446L-7.14398 11.9998H-8.04004V9.85143L-4.86423 8.08672H-8.04004V3.91304H-3.88436L-8.04004 1.60355V0H-6.1641L-0.996548 2.87051V0H2.91649V3.41522L9.06392 0H9.95998Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.08497 -0.000244141H-0.165031V4.87467H-8.04004V7.12467H-0.165031V11.9997H2.08497V7.12467H9.95998V4.87467H2.08497V-0.000244141Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.9165 8.08667L9.95999 11.9997V10.8932L4.90825 8.08667H2.9165Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.9165 8.08667L9.95999 11.9997V10.8932L4.90825 8.08667H2.9165Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.91649 8.08667L9.95998 11.9997V10.8932L4.90823 8.08667H2.91649ZM-2.98836 8.08667L-8.04004 10.8932V11.9997L-0.996548 8.08667H-2.98836Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.996548 3.91279L-8.04004 -0.000244141V1.10626L-2.98829 3.91279H-0.996548ZM4.9083 3.91279L9.95998 1.10626V-0.000244141L2.91649 3.91279H4.9083Z",
					fill: "#D80027"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_187`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as PNFlag };
